
import { mapState } from "vuex";

export default {
  name: "StorePage",

  head() {
    return {
      script: [
        {
          hid: "google-maps-init",
          pbody: true,
          type: "text/javascript",
          innerHTML: `function initMap() {
            setTimeout(() => {
              window.$nuxt?.$store.dispatch("app/setGoogleMapLoaded");
            }, 100);
          }`,
          "data-cookieconsent": "ignore",
        },
        {
          skip: this.isGoogleMapLoaded,
          once: true,
          hid: "google-maps",
          src: `https://maps.googleapis.com/maps/api/js?key=${this.$config.googleMapsApiKey}&libraries=geometry&callback=initMap&loading=async`,
          async: true,
          "data-cookieconsent": "ignore",
        },
      ],
      __dangerouslyDisableSanitizersByTagID: {
        "google-maps": ["data-cookieconsent"],
        "google-maps-init": ["innerHTML", "data-cookieconsent"],
      },
    };
  },

  computed: {
    ...mapState(["siteConfig"]),
    ...mapState("app", ["isGoogleMapLoaded"]),
  },
};
